<template>
<section>
    <p><strong>{{ $t('lang.user-notice.if-youre-not-ready-to-agree-to-this') }} <a href="/faqs" target="_blank">{{ $t('lang.user-notice.heres-some-faqs-link') }}</a> {{ $t('lang.user-notice.to-help-you-decide') }}</strong></p>
    <p>{{ $t('lang.user-notice.were-introducing-a-new-channel-called-workplace') }}</p>

    <p>{{ $t('lang.user-notice.before-you-jump-right-in') }}</p>

    <p>{{ $t('lang.user-notice.for-the-purposes-of-this-user-notice') }}</p>

    <h2 id="heading-1" data-magellan-target="heading-1">{{ $t('lang.user-notice.heading-1') }}</h2>

    <p>{{ $t('lang.user-notice.workplace-is-where-colleagues-can-go-to') }}</p>
    <p>{{ $t('lang.user-notice.workplace-is-where-you-can-celebrate-success') }}</p>
    <p>{{ $t('lang.user-notice.you-can-access-workplace-from-any') }}</p>

    <h2 id="heading-2" data-magellan-target="heading-2">{{ $t('lang.user-notice.heading-2') }}</h2>

    <p>{{ $t('lang.user-notice.we-want-everyone-to-get-involved') }}</p>
    <p>{{ $t('lang.user-notice.if-you-publish-personal-information') }}</p>
    <p>{{ $t('lang.user-notice.please-be-respectful-of-individuals') }}</p>
    <p>{{ $t('lang.user-notice.please-note-that-sharing-of-work') }}</p>
    <p>{{ $t('lang.user-notice.list-please-dont') }}</p>

    <ul class="multi-list">
      <li>{{ $t('lang.user-notice.list-share-commercially-sensitive') }}</li>
      <li>{{ $t('lang.user-notice.list-upload-legal-or-other') }}</li>
      <li>{{ $t('lang.user-notice.list-share-any-personal-customer') }}</li>
      <li>{{ $t('lang.user-notice.list-breach-copyright') }}</li>
      <li>{{ $t('lang.user-notice.list-share-posts') }}</li>
      <li>{{ $t('lang.user-notice.list-upload-or-share') }}</li>
      <li>{{ $t('lang.user-notice.list-share-any-financial') }}</li>
      <li>{{ $t('lang.user-notice.list-share-any-photos-where-any') }}</li>
      <li>{{ $t('lang.user-notice.list-add-groups-of-people') }}</li>
      <li>{{ $t('lang.user-notice.list-share-any-of-the-below') }}
        <ul v-html="$t('lang.user-notice.list-sublist')">
        </ul>
      </li>
    </ul>

    <ul v-html="$t('lang.user-notice.list-post-list')">
    </ul>

    <p>{{ $t('lang.user-notice.please-note-if-you-are-uploading') }}</p>
    <p>{{ $t('lang.user-notice.if-youre-not-sure-dont-post-it') }}</p>


    <h2 id="heading-3" data-magellan-target="heading-3">{{ $t('lang.user-notice.heading-3') }}</h2>

    <p v-html="$t('lang.user-notice.workplace-should-only-be-used')"></p>

    <p>{{ $t('lang.user-notice.be-aware-of-following-policies') }}</p>

    <ul v-html="$t('lang.user-notice.list-policy-links')">
    </ul>

    <h2 id="heading-4" data-magellan-target="heading-4">{{ $t('lang.user-notice.heading-4') }}</h2>

    <p>{{ $t('lang.user-notice.in-order-to-create-accounts') }}<p>
      
    <p>{{ $t('lang.user-notice.bt-will-only-be-directly-providing') }}</p> 
    <ul>
      <li>{{ $t('lang.user-notice.list-name-first-name') }}</li>
      <li>{{ $t('lang.user-notice.list-job-title') }}</li>
      <li>{{ $t('lang.user-notice.list-ouc') }}</li>
      <li>{{ $t('lang.user-notice.list-line-manager') }}</li>
      <li>{{ $t('lang.user-notice.list-work-email-address') }}</li>
      <li>{{ $t('lang.user-notice.list-work-landline-phone') }}</li>
      <li>{{ $t('lang.user-notice.list-work-mobile-phone') }}</li>
      <li>{{ $t('lang.user-notice.list-building-location-code') }}</li>
    </ul>
    <p>{{ $t('lang.user-notice.as-part-of-setting-up-your-workplace') }}</p> 
    <p>{{ $t('lang.user-notice.for-the-purpose-of-providing') }}</p> 
    <p><a href="https://intra.bt.com/bt/lgc/legal/privacy/Data%20Privacy%20Compliance%20Pages/Data%20Privacy/Pages/Data-Privacy-Policies.aspx" target="_blank">{{ $t('lang.user-notice.link-the-bt-employee-privacy-policy') }}</a> {{ $t('lang.user-notice.covers-all-the-detail-about') }}</p>
    <p>{{ $t('lang.user-notice.facebook-stores-this-data-on') }}</p>
    <p>{{ $t('lang.user-notice.bt-has-contractual-provisions') }}</p>
    <p>{{ $t('lang.user-notice.our-contract-with-facebook') }}</p>
    <p>{{ $t('lang.user-notice.if-you-leave-bt') }}</p>
    <p>{{ $t('lang.user-notice.review-your-profile') }}</p>


    <h2 id="heading-5" data-magellan-target="heading-5">{{ $t('lang.user-notice.heading-5') }}</h2>

    <p>{{ $t('lang.user-notice.in-order-to-protect-our') }}</p>
    <ul>
      <li>{{ $t('lang.user-notice.list-edisclosure-for-legal') }}</li>
      <li>{{ $t('lang.user-notice.list-information-retention') }}</li>
      <li>{{ $t('lang.user-notice.list-employee-request-erasure') }}</li>
      <li>{{ $t('lang.user-notice.list-delete-prohibited-content') }}</li>
    </ul>
    <p>{{ $t('lang.user-notice.internal-comms-use-aware') }}</p>
    <p>{{ $t('lang.user-notice.BT-has-legal-duty') }}</p>
    <p>{{ $t('lang.user-notice.aware-stores-and-processes') }}</p>
    <p>{{ $t('lang.user-notice.bt-as-the-controller') }}</p>
    <p>{{ $t('lang.user-notice.in-addition-facebook-deploys') }}</p>
    <p>{{ $t('lang.user-notice.if-content-that-breaches') }}</p>
    <p>{{ $t('lang.user-notice.if-you-want-to-find-out-more') }} <a href="https://www.awarehq.com/" target="_blank">{{ $t('lang.user-notice.link-aware-website') }}</a>.</p> 


    <h2 id="heading-6" data-magellan-target="heading-6">{{ $t('lang.user-notice.heading-6') }}</h2>

    <p>{{ $t('lang.user-notice.bt-reserves-the-right') }}</p>
    <p>{{ $t('lang.user-notice.for-third-party-colleagues') }}</p>

    <h2 id="heading-7" data-magellan-target="heading-7">{{ $t('lang.user-notice.heading-7') }}</h2>
    <p v-html="$t('lang.user-notice.its-your-responsibility')"></p>
    <p>{{ $t('lang.user-notice.if-you-have-concerns-or-complaints') }}</p>
    <p v-html="$t('lang.user-notice.if-you-are-an-administrator')"></p>
    
      <i18n path="lang.user-notice.you-can-access-and-update" tag="p">
        <a :href="'mailto:'+$t('lang.user-notice.complaint-review-legal-support-email')">{{ $t('lang.user-notice.complaint-review-legal-support-email') }}</a>
      </i18n>
    
    <p>{{ $t('lang.user-notice.for-more-information-or-if') }}</p>
    <ul v-html="$t('lang.user-notice.contact-more-list')">
    </ul>

    <h2 id="heading-8" data-magellan-target="heading-8">{{ $t('lang.user-notice.heading-8') }}</h2>

    <p>{{ $t('lang.user-notice.this-user-notice-is-owned') }}</p>
    <p v-html="$t('lang.user-notice.this-user-notice-will-be-amended')"></p>
    <p>{{ $t('lang.user-notice.were-really-excited') }}</p>
  </section>
</template>
<script>
  export default {
    name: 'UserAgreementUK',
    friendlyName: "UK",
    title: 'Workplace user notice',
    mounted: function () {
      this.$nextTick(function () {
        this.$parent.reinitFoundation()
      })
    }
  }
</script>